import React, {Component} from 'react';
import Logo from './../../images/logo_HPS_picea.svg';
import ButtonWinter from './../../images/Winter_Button.svg';
import ButtonSummer from './../../images/Summer_Button.svg';
import ButtonNight from './../../images/Night_Button.svg';
import ButtonDay from './../../images/day_Button.svg';
import BulbEmpty from './../../images/Empty_bulb_button.svg';
import BulbHalf from './../../images/half_bulb_button.svg';
import BulbFull from './../../images/full_bulb_button.svg';

class Menu extends Component {
	constructor (props) {
		super(props);

		this.setDate = props.setDateHandler;
		this.setLoad = props.setLoadHandler;

		this.changeSeason = this.changeSeason.bind(this);
		this.changeDaytime = this.changeDaytime.bind(this);
		this.changeLoad = this.changeLoad.bind(this);
	}

	changeSeason() {
		let now = this.props.now;
		let newMonth = now.getMonth()==0 ? 6 : 0;
		now.setMonth(newMonth);
		this.setDate(now);
		return this;
	}

	changeDaytime() {
		let now = this.props.now;
		let newHours = now.getHours()==0 ? 12 : 0;
		now.setHours(newHours);
		this.setDate(now);
		return this;
	}

	changeLoad() {
		let load = this.props.load;
		let newLoad = null;

		if (load==0) {
			newLoad = 1;
		} else if (load==1) {
			newLoad = 10;
		} else {
			newLoad = 0;
		}
		this.setLoad(newLoad);
		return this;
	}

	render() {	
		let bulb;
		{ if (this.props.load == 0) { 
			bulb = <BulbEmpty height="120px" width="120px" />;
		} else if (this.props.load == 1) { 
			bulb = <BulbHalf height="120px" width="120px" />;			    		
		} else {				
			bulb = <BulbFull height="120px" width="120px" />;
		}}		
		return (
			<div>
				<div style={LogoStyle}>
		    		<Logo 
		    			height="170px"
		    			width="100%"
		    		/>
	    		</div>
				<div style={MenuStyle}>
					
		    		<div id="season" style={ButtonStyle} onClick={this.changeSeason}>		
		    			{ this.props.now.getMonth() == 0 ? (
			    			<ButtonWinter height="120px" width="120px" />
			    		) : (
			    			<ButtonSummer height="120px" width="120px" />			    		
			    		)}
			    	</div>
		    		<div id="daytime" style={ButtonStyle} onClick={this.changeDaytime}>			
		    			{ this.props.now.getHours() == 0 ? (
			    			<ButtonNight height="120px" width="120px" />
			    		) : (
			    			<ButtonDay height="120px" width="120px" />			    		
			    		)}					
		    		</div>			
		    		<div id="load" style={ButtonStyle} onClick={this.changeLoad}>	
		    			{bulb}	    		
		    		</div>	
				</div>
			</div>
    	);
	}
}

const LogoStyle = {
	float: 'left',
	margin: '10px 40px'
}

const MenuStyle = {
	float: 'right',
	margin: '20px'
}

const ButtonStyle = {
	margin: '20px',
	display: 'inline-block',
	cursor: 'pointer',	
	WebkitTapHighlightColor: 'rgba(0,0,0,0)'
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu/index.jsx